module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_short_back_vector.7ace43d3.svg";